/**
 * Admin Routes - Single source of truth for all admin navigation paths
 * Use these constants everywhere to prevent typo-goblins and route mismatches.
 * 
 * Usage:
 *   import { ADMIN_ROUTES } from '../config/adminRoutes';
 *   navigate(ADMIN_ROUTES.AUDIT);
 */

export const ADMIN_ROUTES = {
  DASHBOARD: "/admin",
  GUARDIANS: "/guardians",
  MODERATION: "/admin/moderation",
  REPORTS: "/admin/reports",
  REPORT_DETAIL: (id) => `/admin/reports/${id}`,
  DISPUTES: "/admin/disputes",
  LOVELINK_EARNINGS: "/admin/lovelink/earnings",
  USER_360: (userId) => `/admin/users/${userId}`,
  USER_ENTITLEMENTS: (userId) => `/admin/users/${userId}/entitlements`,
  AUDIT: "/admin/audit",
  REVENUE: "/admin/revenue",
  PAYOUTS: "/admin/payouts",
  VALUE_PAYOUTS: "/admin/value-payouts",
  ANALYTICS: "/admin/analytics",
  SPEED_DATING_OVERRIDES: "/admin/speeddating/overrides",
  INITIATIVES_OPS: "/admin/initiatives",
  // Room Prompts System
  ROOMS: "/admin/rooms",
  ROOM_PROMPTS: "/admin/room-prompts",
  // Legacy aliases
  ROOM_PROMPTS_ALT: "/admin/rooms/prompts",
  ROOM_TOPICS: "/admin/room-topics",
  // Special Date Topics (holiday/event overrides)
  SPECIAL_TOPICS: "/admin/special-topics",
  // Women's Circles
  CIRCLES: "/admin/circles",
};

export default ADMIN_ROUTES;
